export const newsHighlight = {
  default: {
    width: '12',
    hidden: false,
  },
  sm: {
    width: '12',
    hidden: false,
  },
  md: {
    width: '12',
    hidden: false,
  },
  lg: {
    width: '8',
    hidden: false,
  },
  xl: {
    width: '8',
    hidden: false,
  },
};

export const newsItemGrid = {
  default: {
    width: '12',
    hidden: false,
  },
  sm: {
    width: '12',
    hidden: false,
  },
  md: {
    width: '6',
    hidden: false,
  },
  lg: {
    width: '4',
    hidden: false,
  },
  xl: {
    width: '4',
    hidden: false,
  },
};

export const newsOverview = {
  default: {
    width: '12',
    hidden: true,
  },
  sm: {
    width: '12',
    hidden: true,
  },
  md: {
    width: '6',
    hidden: true,
  },
  lg: {
    width: '4',
    hidden: false,
  },
  xl: {
    width: '4',
    hidden: false,
  },
};

export default null;
